import Axios from 'axios';

export const searchProgramsApi = ({authToken, deviceId, userId, merchantId, isFreeVoucher, storeId, isGameReward}) => {
    if(authToken != null){
        return Axios({
            method: 'get',
            url: window.ApiURLNew + 'redeem/program/search',
            params: {
                userId : userId,
                merchantId : merchantId,
                programCode : '',
                programName : '',
                page : 0,
                nRecords : 1000,
                isFreeVoucher : isFreeVoucher,
                storeId: storeId,
                isGameReward: isGameReward,
            },
            data: {},
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'authToken': authToken,
                'deviceUniqueId' : deviceId
            }
        });
    };
};

export const viewProgramApi = ({authToken, deviceId, userId, merchantId, id}) => {
    if(authToken != null){

        return Axios({
            method: 'get',
            url: window.ApiURLNew + 'redeem/program/view',
            params: {
                userId : userId,
                merchantId : merchantId,
                programId : id
            },
            data: {},
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'authToken': authToken,
                'deviceUniqueId' : deviceId
            }
        });
    };
};

export const updateProgramApi = ({authToken, deviceId, userId, merchantId, id, data}) => {
    if(authToken != null){

        return Axios({
            method: 'post',
            url: window.ApiURLNew + 'redeem/program/update',
            data: {
                userId: userId,
                merchantId: merchantId,
                programId :id,
                ...data
            },
            headers:{
                'Content-Type': 'application/json',
                'authToken': authToken,
                'deviceUniqueId' : deviceId
            }
        });
    };
};

export const createProgramApi = ({authToken, deviceId, userId, merchantId, data}) => {
    if(authToken != null){

        return Axios({
            method: 'post',
            url: window.ApiURLNew + 'redeem/program/create',
            data: {
                userId: userId,
                merchantId: merchantId,
                ...data
            },
            headers:{
                'Content-Type': 'application/json',
                'authToken': authToken,
                'deviceUniqueId' : deviceId
            }
        });
    };
};

export const deleteProgramApi = ({authToken, deviceId, userId, merchantId, id}) => {
    if(authToken != null){
        return Axios({
            method: 'post',
            url: window.ApiURLNew + 'redeem/program/delete',
            data: {
                userId : userId,
                merchantId : merchantId,
                programId: id,
            },
            headers:{
                'Content-Type': 'application/json',
                'authToken': authToken,
                'deviceUniqueId' : deviceId
            }
        });
    };
};
